import { render, staticRenderFns } from "./image-video.vue?vue&type=template&id=1d413a10&scoped=true&"
import script from "./image-video.vue?vue&type=script&lang=js&"
export * from "./image-video.vue?vue&type=script&lang=js&"
import style0 from "./image-video.vue?vue&type=style&index=0&id=1d413a10&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d413a10",
  null
  
)

export default component.exports